var currentPreviewIndex = 0;

var modelPage = {
    model: null,

    init: function() {
        var self = this;

        self.model = {
            id: itemId
        }

        this.initSlider();

        $("#embeded-code-btn").click(function(){
            $('#embeded-code').dialog();
            return false;
        });

        // to source files btn (download)
        $("#to-sources-btn").on("click", function(e) {
            e.preventDefault();
            $("html, body").animate(
                {scrollTop: $("#desc-block").offset().top - 100},
                {
                    complete: function() {
                        var tab = $("#desc-block h2.tab").first();
                        if (!tab.hasClass("active")) {
                            tab.click();
                        }
                    }
                }
            );
        });

        this.initFileTable();

        // report item modal
        $("#report-model-btn").magnificPopup({
            type: "inline"
        });
        $("#report-model-modal form").on("submit", function(e) {
            e.preventDefault();
            var feedback = $("#report-model-modal .feedback");
            feedback.hide();
            $.ajax({
                url: $(this).attr("action"),
                method: 'post',
                data: $(this).serialize(),
                dataType: "json",
                success: function(resp) {
                    feedback.show();
                    alertify.success(resp.message, 8000);
                    $("#report-model-btn").magnificPopup("close");
                    $("#report-model-modal form")[0].reset();
                    feedback.hide();
                    feedback.html(resp.message);
                },
                error: function(xhr, status) {
                    let msg = "";
                    if (xhr.responseJSON && xhr.responseJSON.errors) {
                        msg += xhr.responseJSON.errors[Object.keys(xhr.responseJSON.errors)[0]][0];
                    }
                    if (msg.length==0 && xhr.responseJSON && xhr.responseJSON.message) {
                        msg += xhr.responseJSON.message;
                    }
                    feedback.html(msg);
                    feedback.removeClass("alert-info").addClass("alert-warning").show();
                    grecaptcha.reset();
                }
            });
        });

        this.initLicense();

        this.initReviews();
    },

    initSlider: function() {
        var slideCount = $("#image-previews").children().length;
        var imgElem = $('#preview');
        var loaderElement = $("#previews .loader");

        imgElem.on("load", function(e){
            loaderElement.hide();
        });
        $("#model-viewer").on("load", function(e) {
            loaderElement.hide();
        });

        $("#image-previews").slick({
            infinite: false,
            slidesToShow: 5,
            speed: 200,
            prevArrow: "<div class='slick-prev'><i class='fa fa-chevron-left'></div>",
            nextArrow: "<div class='slick-next'><i class='fa fa-chevron-right'></div>",
            focusOnSelect: true,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 993,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        }).on("beforeChange", function(event, slick, currentSlide, nextSlide){
            var url = $(slick.$slides.get(nextSlide)).data("imageUrl");
            var title = $(slick.$slides.get(nextSlide)).attr("title");
            showImageInSlider({
                url: url,
                title: title,
                index: nextSlide,
                previousIndex: currentSlide
            });
        }).slick("slickGoTo", 0);

        $('.slider a.btnPrev').click(function(){
            $("#image-previews").slick("slickPrev");
            return false;
        });
        $('.slider a.btnNext').click(function(){
            $("#image-previews").slick("slickNext");
            return false;
        });

        /**
         * Shows an image in the main slider.
         */
        function showImageInSlider(image) {
            var imgElem = $('#preview');
            if (!$('#previewContainer').is(':visible'))
            {
                $('#previews li').not("li.loader").hide();
                $('#previewContainer').show();
            }
            imgElem.attr('src', image.url);
            imgElem.attr('fpath', image.url);
            imgElem.attr('title', image.title);

            if (image.index>0) {
                $('.slider a.btnPrev').show();
            } else {
                $('.slider a.btnPrev').hide();
            }

            if (image.index+1<slideCount) {
                $('.slider a.btnNext').show();
            } else {
                $('.slider a.btnNext').hide();
            }

            if (image.index!=image.previousIndex) {
                // show the loader icon, then hide it
                loaderElement.show();
            }
        }

        // shows the video in the slider
        $('.btnPreviewVideo').click(function(){
            $('#previews li').not("li.loader").hide();

            var cont = $('#videoContainer');

            if (cont.find("iframe").length==0) {
                var iframe = document.createElement("iframe");
                iframe.src = cont.data("src");
                iframe.width = cont.data("width");
                iframe.height = cont.data("height");

                cont.append(iframe);
            }

            cont.show();
            return false;
        });

        // shows the 360 view
        var showPreviewModel = function()
        {
            $('.slider a.btnPrev, .slider a.btnNext').hide();

            if (App._3dFrame.on) {
                return ;
            }
            loaderElement.show();
            // reel
            $("#model-viewer").attr("src", App._3dFrame.src);
            $("#model-viewer").reel({
                image: App._3dFrame.src,
                frames: App._3dFrame.frames,
                cw: true,
                brake: 0.05
            });
            App._3dFrame.on = true;
        }

        $('.btnPreviewModel').click(function(e){
            e.preventDefault();

            if (!App._3dFrame.frames) {
                return false;
            }

            $("#previews li").not("li.loader").hide();
            $('#modelContainer').show();
            showPreviewModel();
        });
    },

    getSelectedFiles: function(asObject) {
        var container = $("#file-table-cont");
        var list = [];
        container.find("tbody input[type='checkbox']:checked").each(function(){
            if (asObject) {
                list.push($(this).data());
            } else {
                list.push($(this).data("id"));
            }
        });

        return list;
    },

    // source files contents
    initFileTable: function() {
        var self = this;
        const container = $("#file-table-cont");

        // version selector for source sets
        container.on("change", "#version-selector", function() {
            $("#file-table-cont .loader").show();
            $.ajax({
                url: container.data('render-url'),
                data: {
                    legacy: 1,
                    model: self.model.id,
                    version: this.value
                },
                success: function(resp) {
                    $("#file-table-cont").html(resp);
                    $("#file-table-cont .loader").hide();

                    self.initMultiPrintWith();
                    container.find("table").find(".ui-show-more button").on("click", function() {
                        container.find("table").removeClass("compact");
                    });
                }
            });
        });

        // single file downloads
        container.on("click", 'tbody [data-download]', function(e) {
            e.preventDefault();
            if ($(this).attr("disabled")) {
                return ;
            }
            self.downloadRequest(this, $(this).data('download'));
        });

        // single file print-with
        container.on("click", 'tbody [data-print-with]', function(e) {
            var item = $(this).data();
            const url = $(this).data("url");

            if ($(this).attr("disabled")) {
                return ;
            }

            $.magnificPopup.open({
                items: {
                    type: "inline",
                    src: $("#printwith-modal")
                },
                callbacks: {
                    open: function() {
                        // request the server to start the transfer
                        self.sendPrintWithRequest(this, [item], url);
                    },
                    close: function() {
                        // cancel the request
                        self.printWithRequestXhr && self.printWithRequestXhr.abort();
                    }
                }
            });
        });

        // checkboxes: rows
        container.on("change", "tbody input[type='checkbox']", function(e) {
            modelPage.onFileTableCheck();
        });
        // checkbox toggler
        container.on("change", "thead input[type='checkbox']", function(e) {
            var checked = this.checked;
            container.find("tbody input[type='checkbox']").prop("checked", checked);
            modelPage.onFileTableCheck();
            container.find("table").removeClass("compact");
        });

        // multiple downloads
        container.on("click", "thead button[data-download]", function(e){
            self.downloadRequest(this, $(this).data("download") + "?ids=" + self.getSelectedFiles().join(","));
        });

        this.initMultiPrintWith();

        // Start with "compact" mode for file table where only first several files are shown, then expand when appropriate
        const table = container.find("table");
        table.addClass("compact");
        table.find(".ui-show-more button").on("click", function() {
            container.find("table").removeClass("compact");
        });
    },

    /**
     * Sets up handlers for the "print with" buttons on top of the file table
     */
    initMultiPrintWith: function() {
        var container = $("#file-table-cont");
        var self = this;

        self.printWithRequestXhr && self.printWithRequestXhr.abort();

        // multiple print with
        container.find("thead [data-print-with]").magnificPopup({
            items: {
                type: "inline",
                src: $("#printwith-modal")
            },
            callbacks: {
                open: function() {
                    // request the server to start the transfer
                    self.sendPrintWithRequest(this, self.getSelectedFiles(true), this.st.el.data("url"));
                },
                close: function() {
                    // cancel the request
                    self.printWithRequestXhr && self.printWithRequestXhr.abort();
                }
            }
        })
    },

    initLicense: function() {
        $("#license").on("change", function(e) {
            var selOpt = $(this).find(":selected");
            $("#price").text(selOpt.data("price"));
            $("#license-url").attr("href", selOpt.data("url"));

            // add license data to the "cart" button so it's available when needed
            $(".btnPurchase").data("license", selOpt.data("license"));
        });
    },

    /**
     *
     */
    downloadRequest: function(btn, url) {
        var self = this;
        $(btn).prop("disabled", true).attr("disabled", true).find(".text").text("Downloading..");

        $.ajax(url, {
            success: function(resp) {
                if (!resp.status) {
                    return alert("There was an error downloading this file. Please contact our support. Apologizes.");
                }

                $(btn).prop("disabled", false).removeAttr("disabled").find(".text").text("Download");

                if (resp.status == "success") {
                    window.location.href = resp.download_url;
                } else {
                    alertify.error(result.msg, 10000);
                }
            },
            error: function(resp) {
                alertify.error("There was an error downloading this file. Please <a href='" + App.CONTACT_US_URL + "'>contact our support</a>.", 10000);
                $(btn).prop("disabled", false).removeAttr("disabled").find(".text").text("Download");
            }
        });
    },

    printWithRequestXhr: null,

    /**
     * Sends a server request to start a Treatstock upload with given files
     * @param modalEl the modal element with info about progress
     * @param files list of file ids
     */
    sendPrintWithRequest: function(modalEl, files, url) {
        var self = this;
        var fileCountText = files.length>1 ? files.length + " files" : "one file";
        $(modalEl.content).find("[data-ui='file-count']").html(fileCountText);

        // compute some estimates
        var transferSpeed = 0.8; //assume 0.8MB/s speed
        var totalMb=0;
        var simpleList = [];
        for(var i=0; i<files.length; i++) {
            totalMb += files[i].size/(1024*1024);
            simpleList.push(files[i].id);
        }

        var toWait = Math.round(totalMb/transferSpeed/60);
        var toWaitText = toWait>1 ? toWait + " minutes" : "up to a minute"
        $(modalEl.content).find("[data-ui='minutes']").html(toWaitText);
        $(modalEl.content).find("[data-ui='service']").html(files[0].printWith);

        self.printWithRequestXhr = $.ajax({
            url: url,
            method: "get",
            data: {
                files: simpleList,
            },
            dataType: "json",
            success: function(resp) {
                $.magnificPopup.instance.close();
                window.location.href = resp.url;
            },
            error: function(xhr, status, error) {
                $.magnificPopup.instance.close();
                if (status!="abort") {
                    alertify.error(xhr.responseJSON ? xhr.responseJSON.message : xhr.responseText);
                }
            }
        }).done(function(){
            self.printWithRequestXhr = null;
        });
    },

    /**
     * Handler for when file table checkboxes are checked
     */
    onFileTableCheck: function() {
        var container = $("#file-table-cont");
        if (container.find("input[type='checkbox']:checked").length>0) {
            // enable appropriate top buttons
            container.find("thead .btn").prop("disabled", false);
            container.find("thead .btn").removeAttr("disabled");   // non-button elements don't work with prop

            $("#version-selector").addClass("highlight");
        } else {
            // disable appropriate top buttons
            container.find("thead .btn").prop("disabled", true);
            container.find("thead .btn").attr("disabled", true);   // non-button elements don't work with prop

            $("#version-selector").removeClass("highlight");
        }
    },

    initReviews: function() {
        var that = this;
        $("#reviews-block").on("click", ".ui-show-more", function() {
            that.loadReviews({nolimit: 1})
        });

        this.loadReviews({});
    },

    loadReviews: function(data) {
        var url = $("#reviews-block").data('url')
        $.get(url, data, function(resp) {
            $("#reviews-block").html(resp);
        });
    }
}

$(document).ready(function(){
    modelPage.init();
});
